import { faEye, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button } from "@hdb/biome-2";
import { useNavigate } from "react-router-dom";

interface DashboardGenericActionsComponentProps {
  onRefetch: () => void;
}

const DashboardGenericActionsComponent: React.FC<
  DashboardGenericActionsComponentProps
> = ({ onRefetch }) => {
  const navigate = useNavigate();

  const navigateToFloorPlan = () => {
    navigate("floorplan");
  };

  return (
    <div
      className="dashboard-generic-actions"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <B2Button onClick={() => navigateToFloorPlan()} variant="default">
        <FontAwesomeIcon icon={faEye} className="fs-7 me-2" />
        Floor Plan View
      </B2Button>

      <B2Button onClick={() => onRefetch()} variant="default">
        <FontAwesomeIcon icon={faRotateRight} className="me-2" />
        Refresh
      </B2Button>
    </div>
  );
};

export default DashboardGenericActionsComponent;
